import { render, staticRenderFns } from "./MyTransferPanel.vue?vue&type=template&id=4a538f28&scoped=true"
import script from "./MyTransferPanel.vue?vue&type=script&lang=js"
export * from "./MyTransferPanel.vue?vue&type=script&lang=js"
import style0 from "./MyTransferPanel.vue?vue&type=style&index=0&id=4a538f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a538f28",
  null
  
)

export default component.exports